import { Injectable } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';

import { UserPresenter } from '../presenter/user.presenter';
import { UsuarioService } from '../../../../services/usuario.service';
import { User } from '../../../../models/user.model';


@Injectable({
  providedIn: 'root'
})
export class UserInteractor {

private _presenter: UserPresenter;

constructor(private usuarioService: UsuarioService){}

setPresenter(presenter: UserPresenter):void{
  this._presenter = presenter;
}

get getuid() {
  return this.usuarioService.uid;
}

editUser(user: User): void {
  this.usuarioService.edit(user, user.uid)
            .subscribe(
                resp => this._presenter.getResponse(resp),
                (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
              );
}

deleteUser(id: string): void {
    this.usuarioService.delete(id)
            .subscribe(
                  resp => this._presenter.getResponse(resp),
                  (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
              );
}

async getUsers(): Promise<User[]> {
  const resp = await this.usuarioService.getAllAsync().then(res=>res).catch(err => err);
  if (resp.ok) {
      this._presenter.isRequestComplete(resp.ok, null, resp);
      return resp.users;
  }
  this._presenter.isRequestComplete(resp.error.ok, resp);
  return [];
}



}
